import { memo } from 'react';
import Box from '@mui/material/Box';

export default memo(Box);
